module.exports = __webpack_public_path__ + "img/service_icon.37988638.svg";